// extracted by mini-css-extract-plugin
export default {"imgdiv":"cc7966113d _94b0f43b1a","img":"affa21a663 c57022f676"};